export default __webpack_public_path__ + "static/media/hexagons-no-2.a28c7879.ogg";